/* Koffi Studio — Featured Collection Marquee
   - Duplicates lane items until enough height for seamless loop
   - Sets duration from section data-speed
   - Optional countdown
*/
(() => {
  const qs = (el, s) => el.querySelector(s);
  const qsa = (el, s) => Array.from(el.querySelectorAll(s));

  function pad2(n){ return String(n).padStart(2,'0'); }

  function parseCountdownEnd(str){
    // accepts "YYYY-MM-DD HH:MM" or ISO
    if (!str) return null;
    const s = String(str).trim();
    // convert "YYYY-MM-DD HH:MM" => "YYYY-MM-DDTHH:MM:00"
    if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}$/.test(s)) {
      return new Date(s.replace(' ', 'T') + ':00');
    }
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function ensureLaneLoop(lane){
    const inner = qs(lane, '[data-fcm-lane-inner]');
    if (!inner) return;

    if (inner.__koffiLooped) return;
    inner.__koffiLooped = true;

    // Keep duplicating children until inner is at least 2x lane height (smooth)
    const laneH = lane.getBoundingClientRect().height;
    if (laneH <= 0) return;

    const maxCopies = 8;
    let copies = 0;

    const cloneOnce = () => {
      const kids = Array.from(inner.children);
      kids.forEach(node => inner.appendChild(node.cloneNode(true)));
    };

    // We want the animation to go from 0 to -50%, so inner must represent 2 "halves".
    // Ensure it is long enough so -50% scroll looks continuous.
    while (inner.scrollHeight < laneH * 2.4 && copies < maxCopies) {
      cloneOnce();
      copies++;
    }
  }

  function initCountdown(section){
    const enabled = section.dataset.countdown === 'true';
    if (!enabled) return;

    const end = parseCountdownEnd(section.dataset.countdownEnd);
    const wrap = qs(section, '[data-fcm-countdown]');
    if (!wrap || !end) return;

    const dd = qs(wrap, '[data-fcm-dd]');
    const hh = qs(wrap, '[data-fcm-hh]');
    const mm = qs(wrap, '[data-fcm-mm]');
    const ss = qs(wrap, '[data-fcm-ss]');
    const expired = qs(wrap, '[data-fcm-expired]');

    let t;

    const tick = () => {
      const now = new Date();
      const diff = end.getTime() - now.getTime();

      if (diff <= 0) {
        dd.textContent = '00';
        hh.textContent = '00';
        mm.textContent = '00';
        ss.textContent = '00';
        if (expired) expired.hidden = false;
        clearInterval(t);
        return;
      }

      const totalSec = Math.floor(diff / 1000);
      const days = Math.floor(totalSec / 86400);
      const hrs = Math.floor((totalSec % 86400) / 3600);
      const mins = Math.floor((totalSec % 3600) / 60);
      const secs = totalSec % 60;

      dd.textContent = pad2(days);
      hh.textContent = pad2(hrs);
      mm.textContent = pad2(mins);
      ss.textContent = pad2(secs);

      if (expired) expired.hidden = true;
    };

    tick();
    t = setInterval(tick, 1000);
  }

  function init(section){
    if (section.__koffiInit) return;
    section.__koffiInit = true;

    const speed = Math.max(6, parseFloat(section.dataset.speed || '22'));
    section.style.setProperty('--koffi-marquee-dur', `${speed}s`);

    qsa(section, '[data-fcm-lane]').forEach(ensureLaneLoop);

    initCountdown(section);

    // re-check after images load
    const imgs = qsa(section, 'img');
    let pending = imgs.length;
    if (!pending) return;

    imgs.forEach(img => {
      if (img.complete) {
        pending--;
        return;
      }
      img.addEventListener('load', () => {
        pending--;
        if (pending <= 0) qsa(section, '[data-fcm-lane]').forEach(l => {
          const inner = qs(l, '[data-fcm-lane-inner]');
          if (inner) inner.__koffiLooped = false;
          ensureLaneLoop(l);
        });
      }, { once: true });
    });
  }

  function initAll(){
    document.querySelectorAll('.koffi-fcm').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target?.querySelector?.('.koffi-fcm');
    if (el) init(el);
  });
})();
